import * as CarriageCstic from "~/Configurators/Carriage/v2/configuration/CarriageCstics";
import type { SerializableDynamicValue } from "~/Configurators/common/v2/types";

export const CarriagesDefaultValues: Record<string, SerializableDynamicValue<string>> = {
  [CarriageCstic.MaterialName]: "",
  [CarriageCstic.SizeCode]: "",
  [CarriageCstic.StandardKits]: "S",
  [CarriageCstic.Coating]: "/",
  [CarriageCstic.Preload]: [
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: ["KWSE", "KWVE", "KWVE..-W"],
      },
      value: "V1",
    },
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: "RWU",
      },
      value: "V3",
    },
  ],
  [CarriageCstic.Accuracy]: [
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: ["KWSE", "KWVE", "KWVE..-W"],
      },
      value: "G3",
    },
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: "RWU",
      },
      value: "G2",
    },
  ],
  [CarriageCstic.CarriageDesign]: [
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: "RWU",
          },
          {
            type: "equals",
            cstic: CarriageCstic.SizeCode,
            value: "100",
          },
        ],
      },
      value: "L",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: "KWVE..-W",
          },
          {
            type: "equals",
            cstic: CarriageCstic.SizeCode,
            value: ["15", "20", "25", "30"],
          },
        ],
      },
      value: "W",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: "KWVE..-W",
          },
          {
            type: "equals",
            cstic: CarriageCstic.SizeCode,
            value: "35",
          },
        ],
      },
      value: "WL",
    },
    "/",
  ],
  [CarriageCstic.GreasingPerGreaseGroup]: "/",
  [CarriageCstic.GreasingLType]: "/",
  [CarriageCstic.LocatingFace]: "O",
  [CarriageCstic.SMDS]: "N",
  [CarriageCstic.CoverStrip]: "N",
  [CarriageCstic.KitsLeft]: [
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: "KWSE",
          },
          {
            type: "equals",
            cstic: CarriageCstic.SizeCode,
            value: "45",
          },
        ],
      },
      value: "230",
    },
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: ["KWVE..-W", "KWSE"],
      },
      value: "100",
    },
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: "RWU",
      },
      value: "120",
    },
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: "KWVE",
      },
      value: "220",
    },
  ],
  [CarriageCstic.KitsCenter]: [
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: ["KWSE", "KWVE", "KWVE..-W"],
      },
      value: "900",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: "RWU",
          },
          {
            type: "equals",
            cstic: CarriageCstic.SizeCode,
            value: "25",
          },
        ],
      },
      value: "910",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: "RWU",
          },
          {
            type: "not",
            value: {
              type: "equals",
              cstic: CarriageCstic.SizeCode,
              value: "25",
            },
          },
        ],
      },
      value: "930",
    },
  ],
  [CarriageCstic.KitsRight]: [
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: "KWSE",
          },
          {
            type: "equals",
            cstic: CarriageCstic.SizeCode,
            value: "45",
          },
        ],
      },
      value: "230",
    },
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: ["KWVE..-W", "KWSE"],
      },
      value: "100",
    },
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: "RWU",
      },
      value: "120",
    },
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: "KWVE",
      },
      value: "220",
    },
  ],
  [CarriageCstic.LubricationConnectorOrientation]: [
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: ["RWU", "KWVE", "KWVE..-W"],
          },
          {
            type: "equals",
            cstic: CarriageCstic.LocatingFace,
            value: "U",
          },
        ],
      },
      value: "BL",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: ["RWU", "KWVE", "KWVE..-W"],
          },
          {
            type: "equals",
            cstic: CarriageCstic.LocatingFace,
            value: "O",
          },
        ],
      },
      value: "BR",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: "KWSE",
          },
          {
            type: "equals",
            cstic: CarriageCstic.LocatingFace,
            value: "U",
          },
        ],
      },
      value: "L",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: "KWSE",
          },
          {
            type: "equals",
            cstic: CarriageCstic.LocatingFace,
            value: "O",
          },
        ],
      },
      value: "R",
    },
  ],
  [CarriageCstic.LubricationConnector]: [
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: ["KWVE", "KWVE..-W"],
          },
          {
            type: "equals",
            cstic: CarriageCstic.SizeCode,
            value: "20",
          },
        ],
      },
      value: "S04",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: ["KWVE", "KWVE..-W"],
          },
          {
            type: "equals",
            cstic: CarriageCstic.SizeCode,
            value: "15",
          },
        ],
      },
      value: "S16",
    },
    {
      condition: {
        type: "or",
        value: [
          {
            type: "equals",
            cstic: CarriageCstic.MaterialName,
            value: "KWSE",
          },
          {
            type: "and",
            value: [
              {
                type: "equals",
                cstic: CarriageCstic.MaterialName,
                value: ["KWVE", "KWVE..-W"],
              },
              {
                type: "not",
                value: {
                  type: "equals",
                  cstic: CarriageCstic.SizeCode,
                  value: ["15", "20"],
                },
              },
            ],
          },
        ],
      },
      value: "S05",
    },
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: "RWU",
      },
      value: "S25",
    },
  ],
  [CarriageCstic.LubricationConnectorPosition]: "M",
  [CarriageCstic.LubricationConnectorAlignment]: [
    {
      condition: {
        type: "equals",
        cstic: CarriageCstic.MaterialName,
        value: "KWSE",
      },
      value: "270°",
    },
    {
      condition: {
        type: "not",
        value: {
          type: "equals",
          cstic: CarriageCstic.MaterialName,
          value: "KWSE",
        },
      },
      value: "/",
    },
  ],
};
